<div class="p-4 hygienesop-container mt-0">
    <h1 class="section-title-hygiene-sop mb-2">{{ 'EVALUATION.STATISTICAL_EVALUATION' | translate }}</h1>
    <p class="col-12 pb-3 pl-0 static-card-desc">{{ 'EVALUATION.HELP_TEXT.FILTER_FUNCTION_MY_HYGIENE_SOP' | translate }}</p>
    <div class="row col p-0">
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor" (click)="emitData({key:'processCompliance'})">
                <h1 class="section-title menuLink">{{ 'DASHBOARD.PROCESS_COMPLIANCE' | translate }}</h1>
                <p>{{'EVALUATION.HELP_TEXT.NO_STERILITY_FUNCTION' | translate}}</p>
            </div>
        </div>
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor" (click)="emitData({key:'frequencyDistribution'})">
                <h1 class="section-title menuLink">{{ 'EVALUATION.FREQUENCY_DISTRIBUTION.DISPLAY_TEXT' | translate }}
                </h1>
                <p>{{ 'EVALUATION.HELP_TEXT.HYGIENE_RELEVANT_MEASURES_AMOUNT' | translate }}</p>
            </div>
        </div>
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor" (click)="emitData({key:'subStepCompliance'})">
                <h1 class="section-title menuLink">{{ 'EVALUATION.SUB_STEP_COMPLIANCE' | translate }}</h1>
                <p>{{ 'EVALUATION.HELP_TEXT.SUB_STEP_COMPLIANCE' | translate }}
                </p>
            </div>
        </div>
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor" (click)="emitData({key:'individualData'})">
                <h1 class="section-title menuLink">{{ 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1' | translate }}</h1>
                <p>{{ 'EVALUATION.HELP_TEXT.OVERVIEW_1' | translate }}
                </p>
            </div>
        </div>
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor" (click)="emitData({key:'comments'})">
                <h1 class="section-title menuLink">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h1>
                <p>{{ 'EVALUATION.HELP_TEXT.GRAPH' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>